import { fabric } from 'fabric';
import { helperSettingsConfig } from '../../../utils';

const { scalingFactor } = helperSettingsConfig;

export const renderIcon = (icon: HTMLImageElement, width = 32, height = width) => {
  return function renderIcon(
    ctx: CanvasRenderingContext2D,
    left: number,
    top: number,
    styleOverride: unknown,
    fabricObject: fabric.Object,
  ): void {
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle ?? 0));
    ctx.drawImage(icon, -width / scalingFactor, -height / scalingFactor, width, height);
    ctx.restore();
  };
};
